<div cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListSortPredicate]="sortAgainstPinned">
  @for (col of columnsFlat; track col) {
    @if (col.id !== 'select') {
      <div class="entry" cdkDrag [cdkDragDisabled]="col.pinned" cdkDragLockAxis="y">
        <mat-icon cdkDragHandle>
          {{ col.pinned ? 'push_pin' : 'drag_indicator' }}
        </mat-icon>
        @if (this.formGroup) {
          <mat-checkbox [disabled]="!!col.pinned" [formControl]="getControl(col.id)">
            {{ col.title }}
          </mat-checkbox>
        }
      </div>
    }
  }
</div>
